import React, { Fragment, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaUser } from "react-icons/fa";
import { FiLock } from "react-icons/fi";
import { MdEmail } from "react-icons/md";
// import "./login.css";

import { useDispatch, useSelector } from "react-redux";
import { clearError, login, register } from '../../actions/userAction'
import { toast } from "react-toastify";
import Loading from "../../components/Loading/loading";

const Register = () => {
  const { error, loading, isAuthenticated } = useSelector((state) => state.users)
const dispatch = useDispatch();
const navigate=useNavigate()

  useEffect(() => {
    if(error){
      toast.error(error)
    }
    if(isAuthenticated){
      navigate("/dashboard")
    }
   
  }, [error,isAuthenticated]);

const [user, setUser] = useState({
  name: "",
  email:"",
  password:"", 
  confirmPassword:""

});
const {name, email, password,confirmPassword } = user;

  const registerSubmit = (e)=>{
 console.log(name, email, password,confirmPassword)

    e.preventDefault();
    
    const myForm = new FormData();
     myForm.set("name",name)
     myForm.set("email",email)
     myForm.set("password",password)
    //  myForm.set("confirmPassword",confirmPassword)
    
     if(password !== confirmPassword){
      toast.error("Password not match")
     }
     else{
       dispatch(register(myForm));
     }
    }
    const registerDataChange = (e)=>{
      setUser({...user , [e.target.name]: e.target.value})
  };
  return (
   <Fragment>
      {
        loading ? <Loading/> : ( <div className="loginContainer">
        <div className="imgBox">
          <img src={require("../../images/sign-up.webp")} alt="image" />
        </div>
        <div>
          <div className="formBox">
            <h2>Sign up</h2>  
            <form action="" onSubmit={(e)=>registerSubmit(e)}>
              <div>
                <FaUser />
                <input type="text" className="logInpBtn" placeholder="Name" name="name" value={name} onChange={registerDataChange} />
              </div>
              <div>
                <MdEmail />
                <input type="email" className="logInpBtn" placeholder="Email" name="email" value={email} onChange={registerDataChange}/>
              </div>
              <div>
                <FiLock />
                <input
                  type="password"
                  className="logInpBtn"
                  placeholder="Password"
                  value={password} onChange={registerDataChange}
                  name="password"
                />
              </div>
              <div>
                <FiLock />
                <input
                  type="password"
                  className="logInpBtn"
                  placeholder="Comfirm Password"
                  name="confirmPassword"
                  value={confirmPassword} onChange={registerDataChange}
                />
              </div>
              <div>
                <input type="submit" className="submintBtn" value="Register" />
  
              </div>
            </form>
            <div className="regBox">
              {/* <p>I m New </p> */}
             
              <Link className="submintBt" to={"/"}>
                Log in
              </Link>
            </div>
          </div>
        </div>
      </div>)
      }
   </Fragment>
  );
};

export default Register;
